// extracted by mini-css-extract-plugin
module.exports = {"Section2":"Section2_Section2__NCZKg","ContentList":"Section2_ContentList__o6thp"};